import {
  faChartSimple,
  faClock,
  faIdCard,
  faInfoCircle,
  faKey,
  faMobileScreen,
} from '~/assets';
import { currencyParser } from '~/modules';
import {
  PasswordTypesPt,
  TransactionTypePt,
  fillStringIfEmpty,
  formatHourMinuteSecondDate,
  formatPhone,
  getMetadataItemByKey,
  maskCpfOrCnpj,
  parseEnumToPt,
  truncateString,
} from '~/utils';

export const getClientDetailedInfo = (
  client: AuditClientAccount,
): ClientInfoList => [
  { label: 'CENTRO DE CUSTO', value: client.centerCost, icon: faChartSimple },
  { label: 'DOCUMENTO', value: maskCpfOrCnpj(client.document), icon: faIdCard },
  {
    label: 'ÚLTIMO LOGIN',
    value: client.lastDateLoginApp
      ? formatHourMinuteSecondDate(new Date(client.lastDateLoginApp))
      : '-',
    icon: faClock,
  },
  {
    label: 'DISPOSITIVO ATUAL',
    value: fillStringIfEmpty(truncateString(client.currentDevice, 20), '-'),
    icon: faMobileScreen,
  },
  {
    label: 'NÚMERO DO CELULAR',
    value: fillStringIfEmpty(formatPhone(client.phone), '-'),
    icon: faInfoCircle,
  },
  {
    label: 'SENHA FIXA',
    value:
      client.hasFixedPassword === undefined || client.hasFixedPassword === null
        ? '-'
        : client.hasFixedPassword
          ? 'Possuí'
          : 'Não possuí',
    icon: faKey,
  },
  {
    label: 'ÚLTIMA DATA SENHA FIXA',
    value: client.lastDateFixedPassword
      ? formatHourMinuteSecondDate(new Date(client.lastDateFixedPassword))
      : '-',
    icon: faKey,
  },
];

export const transformTransactionToKeyValue = (
  transaction: Transaction,
): Array<{ key: string; value: string }> => {
  const installments = {
    current: getMetadataItemByKey('installment_number', transaction.metadata)
      ?.value,
    amount: getMetadataItemByKey('total_installments', transaction.metadata)
      ?.value,
  };

  const installmentsText = installments.amount
    ? `Parcela ${installments.current} de ${installments.amount}`
    : undefined;

  return [
    {
      key: 'ID',
      value: transaction.id,
    },
    {
      key: 'TX ID',
      value: transaction.transactionId,
    },
    {
      key: 'Tipo',
      value: parseEnumToPt(transaction.transactionType, TransactionTypePt),
    },
    { key: 'Valor', value: currencyParser(transaction.amount || '') },
    { key: 'Parcelas', value: fillStringIfEmpty(installmentsText, '-') },
    {
      key: 'Loja',
      value: fillStringIfEmpty(
        getMetadataItemByKey('store_id', transaction.metadata)?.value,
        '-',
      ),
    },
    {
      key: 'PDV',
      value: fillStringIfEmpty(
        getMetadataItemByKey('pdv', transaction.metadata)?.value,
        '-',
      ),
    },
    {
      key: 'Cupom',
      value: fillStringIfEmpty(
        getMetadataItemByKey('coupon', transaction.metadata)?.value,
        '-',
      ),
    },
    {
      key: 'Tipo de senha',
      value: fillStringIfEmpty(
        parseEnumToPt(
          getMetadataItemByKey(
            'token_type',
            transaction.metadata,
          )?.value?.toLocaleUpperCase(),
          PasswordTypesPt,
        ),
        '-',
      ),
    },
    {
      key: 'Origem',
      value: `${fillStringIfEmpty(transaction.source?.fullName, '-')} (${fillStringIfEmpty(maskCpfOrCnpj(transaction.source?.document), '-')})`,
    },
    {
      key: 'Destino',
      value: `${fillStringIfEmpty(transaction.destination?.fullName, '-')} (${fillStringIfEmpty(maskCpfOrCnpj(transaction.destination?.document), '-')})`,
    },
  ];
};
